import {
  AdSetBudgetType,
  CampaignBudgetType,
  SpecialAdCategory,
  CallToAction,
} from '@mm/state/interfaces/adAccounts';

export const BUDGET_THRESHOLD = 9999999;
export const SAVE_AD = 'Publish Changes';
export const SYNC_ADS = 'Sync Ads';
export const SAVE_ADS = 'Save';
export const PUBLISH_AD_TOP = 'Activate';
export const PUBLISH_AD = `Activate Ad`;
export const DEFAULT_NAME = 'Messenger Ad 1';
export const DEFAULT_CAMPAIGN_NAME = 'Messenger Ad 1';
export const DEFAULT_AD_SET_NAME = 'Messenger Ad 1';
export const DEFAULT_CALL_TO_ACTION = CallToAction.SEND_MESSAGE;
export const DEFAULT_AD_SET_BUDGET_TYPE = AdSetBudgetType.DAILY;
export const DEFAULT_AD_SET_BUDGET = 5;
export const DEFAULT_CAMPAIGN_BUDGET_TYPE = CampaignBudgetType.DAILY;
export const DEFAULT_CAMPAIGN_BUDGET = 31;
export const DEFAULT_BID_AMOUNT = 1;
export const DEFAULT_SPECIAL_AD_CATEGORY = SpecialAdCategory.EMPLOYMENT;
export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const TEMPLATE_ACTIVATE = 'Preview & Activate';
export const PANEL_NAME = 'Click-to-Messenger Ads';
export const MESSAGE_TEXT =
  'The goal of this first message is to get people to respond and become leads.' +
  ' Try writing something very simple, such as a yes-or-no question.';
export const JSON_ICON_TOOLTIP_TEXT =
  'Copy the code below in full. Go to the "Ad Setup" in your Facebook Ad. Click "Messenger Setup". Click "JSON" tab.' +
  ' Click the first bracket and delete all of the default code.' +
  ' Paste the copied code from Customers.ai and click "Done"';
export const REF_TOOLTIP_TEXT =
  'Copy the text below in full. Go to the "Ad Setup" in your Facebook Ad.' +
  ' Click "Show Advanced Options". Paste this into "URL Parameters"';
export const FB_AGE_MIN = 18;
export const FB_AGE_MAX = 65;
export const FB_GENDER_MALE = 1;
export const FB_GENDER_FEMALE = 2;
